import React from 'react';
import { useModalManager } from '@/components/common/Modal';
import { Button } from '@/components/ui/Buttons';
import AddLessonsModal from './AddLessonsModal';

interface AddLessonsProps {
  programId: number;
}

const AddLessons = ({ programId }: AddLessonsProps) => {
  const modalManager = useModalManager();

  return (
    <>
      <Button
        small
        color="green"
        onClick={() => modalManager.open()}
      >
        Add Lessons
      </Button>
      {modalManager.isOpen && (
        <AddLessonsModal
          modalManager={modalManager}
          parentProgramId={programId}
        />
      )}
    </>
  );
};

export default AddLessons;
